import { LocalizedLink } from '../primitives';
import styles from './breadcrumbs.module.scss';

import React from 'react';


type BreadcrumbsProps = {
    path: any[];
    separator?: string;
};

export default function Breadcrumbs(props: BreadcrumbsProps) {
    const { path, separator } = props;

    const breadcrumbObjects = path.map((element) => (
        <LocalizedLink to={element.url}>{element.label}</LocalizedLink>
    ));

    return (
        <div className={`${styles.breadcrumbsContainer} container`}>
            {breadcrumbObjects.map((element, index) => {
                if (index > 0)
                    return [
                        <span key={`${index}-sep`}>
                            {separator ? separator : ` / `}
                        </span>,
                        <span key={index}>{element}</span>,
                    ];
                else return [<span key={index}>{element}</span>];
            })}
        </div>
    );
}
